import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BlogDetails from './BlogDetails';
import SinglePostSidebar from './SinglePostSidebar';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import Newsletter from '../../components/Common/Newsletter';
import ScrollToTop from '../../components/Common/ScrollTop';
import OffWrap from '../../components/Layout/Header/OffWrap';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import SearchModal from '../../components/Layout/Header/SearchModal';

// Image
import favIcon from '../../assets/img/fav-orange.png';
import Logo from '../../assets/img/logo/cat_logo.png';
import footerLogo from '../../assets/img/logo/cat_logo.png';

import postImage from '../../assets/img/blog/inner/1.jpg';
import post1Image from '../../assets/img/blog/inner/b3.jpeg'

// Breadcrumbs Background Image
import bannerbg from '../../assets/img/breadcrumbs/5.jpg';

const SinglePostRightSidebar = (props) => {

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu='blog'
                secondParentMenu='blogSingle'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar='enable'
                TopBarClass="topbar-area home8-topbar"
                emailAddress='perfectschool777@gmail.com'
            />

            <SiteBreadcrumb
                pageTitle="Британський акцент з 3 років?"
                pageName="Британський акцент з 3 років?"
                breadcrumbsImg={bannerbg}
            />

            {/* Blog Details Start */}
            <div className="rs-inner-blog orange-style pt-100 pb-100 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 order-last">
                            <div className="widget-area">
                                <SinglePostSidebar />
                            </div>
                        </div>
                        <div className="col-lg-8 pr-50 md-pr-14">
                          <div className="blog-deatails">
                            <div className="bs-img">
                                <img
                                    src={post1Image}
                                    alt="Post Image"
                                />
                            </div>
                            <div className="blog-full">
                                <div className="blog-desc">
                                    <p>
                                      Звичайно, все можливе! Скажімо, навіть, чим раніше, аж з дитинства, дитина почне чути британський акцент, тим легше сприйматиме мову, як свою рідну. Адже будь-які Іноземні для дитини Мови сприймаються в 2 рази гірше. Причина у специфічних тональностях та тембрах кожної мови. У такому ранньому віці мозок характеризується неймовірним рівнем навчання. Інформація про особливості мови записується лише на рівні інстинктів. У ранньому віці акцент дуже гнучкий. Мозок дитини в дошкільному віці чудово адаптується до мов. Тому дитина з легкістю може навчитися говорити іноземною мовою без акценту. Ну або з британським акцентом) У вчених немає єдиної думки, коли мовний апарат втрачає свою гнучкість та сприйнятливість. Але більшість сходиться на думці, що це ранній шкільний вік приблизно від 5 до 9 років. Якщо мета - закріпити певний акцент, не гайте часу!) Адже «Перезаписати» артикуляцію, вивчену ще в дитинстві, неможливо. Але можна «записати» ще одну, на кшталт дітей-білінгвів. Ось тільки дітям це вдається без проблем, а у дорослому віці для цього потрібні величезні зусилля. А якщо ідеальний британський чи американський акцент вам не потрібен, варто зосередитися на вивченні мови в цілому. Адже правильно і грамотно висловлювати свої думки набагато важливіше, ніж ідеально артикулювати звук [æ]. Але вибір завжди залишається за Вами :)
                                    </p>
                                </div>
                            </div>
                        </div>
                            {/* <BlogDetails /> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Blog Details End */}

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop
                scrollClassName="scrollup orange-color"
            />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
}


export default SinglePostRightSidebar;



